import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import { TinyLetter } from 'react-tinyletter'
import { rhythm } from '../utils/typography'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')

    return (
      <div>
        <Helmet title={`${post.frontmatter.title}`} />
        {post.frontmatter.cover ? (
          <div style={{
            marginTop: '1em',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundImage: `url('${post.frontmatter.cover}')`,
            width: '100%',
            height: '240px'
          }}></div>
        ) : null}
        <h1
          style={{
            color: '#f44336'
          }}
        >
          {post.frontmatter.title}
        </h1>
        <em>{post.frontmatter.date}</em>
        <div style={{
          marginTop: '1em'
        }}>
          <div className="post" dangerouslySetInnerHTML={{ __html: post.html }} />
        </div>
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
      </div>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        date(formatString: "MMMM YYYY")
        cover
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js